import React from "react";
import { H3 } from "../../../../AbstractElements";
import { RowsSelectionAndDeletions, RowSelectionAndDeletionHeaderSpan } from "../../../../Constant";

const RowSelectionAndDeletionHeader = () => {
  return (
    <div className="card-header pb-0 card-no-border">
      <H3 className="mb-3">{RowsSelectionAndDeletions}</H3>
      <span dangerouslySetInnerHTML={{ __html: RowSelectionAndDeletionHeaderSpan }}></span>
    </div>
  );
};

export default RowSelectionAndDeletionHeader;
